import {Activity} from 'types';

export const allDay = (activity: Activity | undefined) => {
  return activity?.allDay ?? activity?.duration === 24 * 60;
};
